export const getQueryParam = (queryStr, name) => {
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(queryStr);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

// '/admins/add' --> ['/admins', '/admins/add']
export const getSplitPath = (path) => {
  const pathList = path.split('/');
  return pathList.map((path, i) => {
    const pathStr = pathList.slice(1, i + 1).join('/'); // skip the first one '/'
    return `/${pathStr}`;
  });
};




// WEBPACK FOOTER //
// ./src/utils/util.js